import { Component, Input, OnInit } from "@angular/core";
import { PlayerDto } from "app/models";

@Component({
    selector: 'tactic-player-info',
    templateUrl: './tactic-player-info.component.html',
    styleUrls: ['./tactic-player-info.component.scss'],
})
export class TacticPlayerInfo implements OnInit {
    private pl:PlayerDto;


    @Input()
    set player(val: PlayerDto) {
        this.pl = val;
        this.form  = this.getPlayerForm();
        this.morale = this.getPlayerMorale();
    }

    get player(): PlayerDto {
        return this.pl;
    }

    @Input()
    isSubst: boolean;

    form: number;
    morale: number;

    ngOnInit(): void {
        this.form  = this.getPlayerForm();
        this.morale = this.getPlayerMorale();
    }

    getPlayerPower(): any {
        if (!this.player) {
            return null;
        }

        return this.player.power;
    }

    private getPlayerMorale(): any {
        if (!this.player) {
            return null;
        }

        return this.player.morale;
    }

    private getPlayerForm(): number {
        if (!this.player) {
            return null;
        }

        return this.player.form;
    }
}